import { render, staticRenderFns } from "./SidebarWm.vue?vue&type=template&id=28708e01&"
import script from "./SidebarWm.vue?vue&type=script&lang=js&"
export * from "./SidebarWm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports